module.exports = __webpack_public_path__ + "img/4.3ae9e1f6.jpg";